// This component differs from the GradeSelect by grouping grade levels
// into "småtrinn" (1.-4.) and "mellomtrinn" (5.-7.)

import type { GradeGroup } from "@arbeidsark/shared"
import { Select, type SelectOption, type SelectProps } from "~/components"
import { useTranslate } from "~/ur-react-hooks"

export interface GradeLevelGroupSelectProps
  extends Omit<SelectProps<GradeGroup>, "options"> {}

const GradeLevelGroupSelect: React.FC<GradeLevelGroupSelectProps> = ({
  ...props
}) => {
  const translations = useTranslate({
    oneToFour: "worksheets.grade-groups.oneToFour",
    fiveToSeven: "worksheets.grade-groups.fiveToSeven",
  })

  const options: SelectOption<GradeGroup>[] = [
    {
      value: "1-4",
      label: translations.oneToFour,
    },
    {
      value: "5-7",
      label: translations.fiveToSeven,
    },
  ]

  return <Select {...props} options={options} />
}

export default GradeLevelGroupSelect
